import React, { useMemo, useState } from "react";
import { Dropdown } from "react-bootstrap";

const DropdownTable = ({ title, options, value, onChange }) => {
  const isControlled = typeof onChange === "function";
  const [uncontrolledValue, setUncontrolledValue] = useState([]);
  const selectedOptions = isControlled ? value ?? [] : uncontrolledValue;

  const selectedLabel = useMemo(() => {
    if (!selectedOptions || selectedOptions.length === 0) return title;
    if (selectedOptions.length === 1) return `${title}: ${selectedOptions[0]}`;
    return `${title}: ${selectedOptions.length} selected`;
  }, [selectedOptions, title]);

  const handleCheckboxChange = (option) => {
    const next =
      selectedOptions && selectedOptions.includes(option)
        ? selectedOptions.filter((o) => o !== option)
        : [...(selectedOptions || []), option];

    if (isControlled) onChange(next);
    else setUncontrolledValue(next);
  };

  return (
    <Dropdown className="dropdown-container">
      <Dropdown.Toggle
        variant="light"
        className="w-100" 
        style={{
          border: "1px solid rgb(200, 32, 39)",
          backgroundColor: "transparent",
          fontWeight: "500",
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderRadius: 0,
          
      
        }}
      >
        {selectedLabel}
      </Dropdown.Toggle>

      <Dropdown.Menu style={{ width: "100%", padding: "0" }}>
        <ul
          style={{
            listStyleType: "none",
            padding: "10px 10px",
            margin: "0",
            boxShadow: '3px 3px 10px 4px #888',
            maxHeight: "min(50vh, 320px)",
            overflowY: "auto",
          }}
        >
          {options.map((option, index) => (
            <li key={index} className="d-flex align-items-center ">
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent:'flex-start',
                  borderBottom: index !== options?.length-1 ? '.5px solid #c6c8c9':'',
                  width:'100%',
                  padding:'8px 10px',
                  // backgroundColor:"red"
                }}
              >
                <input
                  type="checkbox"
                  id={option.code}
                  value={option.name}
                  checked={selectedOptions.includes(option.name)}
                  onChange={() => handleCheckboxChange(option.name)}
                  style={{
                    appearance: "none",
                    width: "24px",
                    height: "24px",
                    border: "1px solid rgb(200, 32, 39)",
                    borderRadius: "2px",
                    backgroundColor: selectedOptions.includes(option.name)
                      ? "rgb(200, 32, 39)"
                      : "transparent",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                />
                {selectedOptions.includes(option.name) && (
                  <span
                  onClick={() => handleCheckboxChange(option.name)}
                    style={{
                      color: "white",
                      position: "absolute",
                      left: "4px",
                      top: "8px",
                      fontSize: "18px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    ✓
                  </span>
                )}
                <label htmlFor={option.code} className="ml-2" style={{fontSize:'17px' ,fontWeight:400,
                  fontFamily:'Avenir'
                }}>
                  {option.name}
                </label>
              </div>
            </li>
          ))}
        </ul>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropdownTable;
